export const EMPTY_ARRAY = Object.freeze([]);

export const EMPTY_OBJECT = Object.freeze({});

export const EMPTY_STRING = Object.freeze('');

export const EMPTY_NUMBER = Object.freeze(0);

export const EMPTY_MAP = Object.freeze(new Map());
